'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ScrollAppear = function () {
    function ScrollAppear(el) {
        _classCallCheck(this, ScrollAppear);

        this.el = el;
        this.watcher = scrollMonitor.create(this.el, {top: parseInt(this.el.getAttribute('data-paddingTop'))});
        //events
        this.events();
    }

    _createClass(ScrollAppear, [{
        key: 'events',
        value: function events() {
            var _this = this;

            this.watcher.enterViewport(function () {
                domUtils.addClass(_this.el, 'active');
            });
        }
    }]);

    return ScrollAppear;
}();

var init = function init() {
    var elements = document.querySelectorAll('.scroll-appear');
    Array.prototype.forEach.call(elements, function (el, i) {
        new ScrollAppear(el);
    });
};

domUtils.ready(init);
